export const mutations = {
  setCommunityCollectionsList(state, payload) {
    state.communityCollectionsList = payload;
  },
  setCommunityCollectionsListPageOptions(state, payload) {
    state.communityCollectionsListPageOptions = payload;
  },
  editCollection(state, payload) {
    let collection = state.communityCollectionsList.find((c)=>c.id === payload.id);
    collection.rating = payload.boost ? collection.rating + 1 : collection.rating - 1;
  },
  setNextToken(state, payload) {
    state.nextToken = payload;
  },
};
